<template>
  <v-list-item-icon class="mr-3" :class="{ active: unread }">
    <template v-if="notiType == caseCommentAdded">
      <v-icon dense size="18"> $messages </v-icon>
    </template>
    <template v-if="notiType == cameraMotionDetected">
      <v-icon dense size="20"> $walkIcon</v-icon>
    </template>
    <template v-if="notiType == deviceStatusUpdated">
      <v-icon dense size="20"> $cameraIcon </v-icon>
    </template>
    <template v-if="notiType == digitalInput">
      <v-icon dense size="20">mdi-alarm-light</v-icon>
    </template>
    <template v-if="notiType == vcaEvent">
      <v-icon dense size="20">mdi-alarm-light</v-icon>
    </template>
  </v-list-item-icon>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import {
  CASE_COMMENT_ADDED,
  CAMERA_MOTION_DETECTED,
  DEVICE_STATUS_UPDATED,
  DIGITAL_INPUT,
  VCA_EVENT,
} from '@/constants/notificationTypes.js'

export default defineComponent({
  name: 'NotificationTypeIcons',
  props: {
    notiType: {
      type: Number,
      required: true,
    },
    unread: {
      type: Boolean,
      required: true,
    },
    payload: {
      type: Object,
      required: true,
    },
  },
  computed: {
    caseCommentAdded() {
      return CASE_COMMENT_ADDED
    },
    cameraMotionDetected() {
      return CAMERA_MOTION_DETECTED
    },
    deviceStatusUpdated() {
      return DEVICE_STATUS_UPDATED
    },
    digitalInput() {
      return DIGITAL_INPUT
    },
    vcaEvent() {
      return VCA_EVENT
    },
  },
})
</script>

<style lang="scss">
.v-list-item__icon {
  .v-icon {
    path {
      fill: white !important;
    }
    g {
      fill: white !important;
    }
  }
  &.active {
    &::before {
      background-color: $color-blue;
    }
  }
  &::before {
    content: '';
    background-color: rgba(255, 255, 255, 0.26);
    border-radius: 50%;
    position: absolute;
    height: 26px;
    width: 26px;
    top: 13px;
    left: 13px;
  }
}
</style>
